// TODO: Componente con un solo llamado, se puede reemplazar por un simple label
// TODO: Eliminar este archivo si no se usa
import React from 'react'
import "./InputLabel.scss"

const InputLabel = ({label}) => {

  return (
    <div className='general-label-container'>
      <label className='general-label'>{label}</label>
    </div>
  )
}

export default InputLabel